import { useEffect, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { api } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { CheckCircle2, Loader2, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const sessionId = params.get("session_id");
  const [state, setState] = useState("checking");

  useEffect(() => {
    let tries = 0;
    let timer;
    const poll = async () => {
      try {
        const { data } = await api.get(`/payments/status/${sessionId}`);
        if (data.payment_status === "paid") return setState("paid");
        if (["expired", "failed"].includes(data.payment_status)) return setState("failed");
      } catch {
        return setState("failed");
      }
      if (++tries >= 15) return setState("timeout");
      timer = setTimeout(poll, 2000);
    };
    poll();
    return () => clearTimeout(timer);
  }, [sessionId]);

  return (
    <div className="mx-auto mt-20 max-w-md rounded-3xl border bg-white p-10 text-center" data-testid="payment-result">
      {state === "checking" && <><Loader2 className="mx-auto mb-4 h-9 w-9 animate-spin text-primary" /><h2 className="text-2xl font-semibold">Confirming your payment…</h2></>}
      {state === "paid" && <><CheckCircle2 className="mx-auto mb-4 h-10 w-10 text-emerald-600" /><h2 className="text-2xl font-semibold" data-testid="payment-success-title">Your stay is confirmed</h2><p className="mt-2 text-stone-600">No guest fees, as promised.</p></>}
      {state === "failed" && <><XCircle className="mx-auto mb-4 h-10 w-10 text-red-600" /><h2 className="text-2xl font-semibold">Payment didn't go through</h2></>}
      {state === "timeout" && <h2 className="text-2xl font-semibold">Still processing. Check your trips in a minute.</h2>}
      <Button asChild className="mt-6 rounded-full" data-testid="payment-go-trips"><Link to="/trips">Go to my trips</Link></Button>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="mx-auto mt-20 max-w-md rounded-3xl border bg-white p-10 text-center" data-testid="payment-cancelled">
      <h2 className="text-2xl font-semibold">Payment cancelled</h2>
      <p className="mt-2 text-stone-600">Your booking is still accepted. You can pay from your trips page.</p>
      <Button asChild className="mt-6 rounded-full"><Link to="/trips">Back to trips</Link></Button>
    </div>
  );
}
